<template>
	<div class="page-header">
		<slot v-if="showBreadcrumbs === 'yes'"></slot>
		<div class="container">
			<img
				:src="image"
				:alt="title"
			/>
		</div>

		<h1
			v-if="title"
			v-html="title"
		></h1>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		title: {
			type: String,
			default: 'Page Title',
		},
		showBreadcrumbs: {
			default: 'yes',
		},
		image: {

		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.page-header {
	max-width: auto;

	#breadcrumbs {
		background-color: $cpmec-grey;

		a,
		span {
			color: white;
		}

		.colour-wrapper {
			background: rgba($cpmec-blue, 0.1);
			.container {
				padding: $spacer;

				span {
					&.divider {
						margin: 0 $spacer;
					}
				}
			}
		}
	}

	.container {
		max-width: 100%;
		height: 385px;

		@media (max-width: $lg) {
					height: 200px;
				}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	h1 {
			font-family: $font-family;
			font-style: normal;
			font-weight: normal;
			font-size: 50px;
			line-height: 60px;
			letter-spacing: 0;
			color: $cpmec-blue;
			margin: calc(var(--spacer) * 2) 0 0;
			width: 100%;
			text-align: center;

			@media (max-width: $lg) {
				font-size: 50px;
				line-height: 50px;
				margin: $spacer 0 0;
				padding: 0 $spacer;
				width: calc(100% - 40px);
			}
		}

	
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PostHeader.vue